import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as contractActions from "../../actions/contractActions";
import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";
import * as expenseActions from "../../actions/expenseActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ExpenseForm from "./ExpenseForm";

// const MIN_PERMISSION_LEVEL = 4000; // BILLING ADMINISTRATOR

export const getCanEdit = (expense, codes) => {
  const expenseCodes =
    codes &&
    codes
      .filter(
        (code) =>
          code.entity === "Expenses" &&
          code.field === "status" &&
          ["Approved", "Completed"].includes(code.label)
      )
      .map((code) => code.id);

  const isEditable = !expenseCodes.includes(
    typeof expense.status === "string" ? expense?.status : expense?.status?.id
  );
  // this shouldn't be necessary once people can only see their own expenses
  // || this.props.auth.maxRole >= MIN_PERMISSION_LEVEL;

  return isEditable;
};

class ExpenseEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = { editing: false, isEditable: true };
  }

  componentDidMount = () => {
    this.props.actions.getExpense(this.props.match.params.id);
  };

  handleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  handleSave = async (expense) => {
    await this.props.actions.updateExpense(expense);
    this.props.history.push("/app/expenses");
  };

  handleCancel = () => {
    this.props.history.push("/app/expenses");
  };

  render() {
    const { users, codes, auth, expense, isMobile, history } = this.props;
    const { editing } = this.state;
    const isEditable = getCanEdit(expense, codes);
    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: `${isEditable ? "Edit " : "View "} Expense` }]}
          onClickEdit={isEditable ? this.handleEdit : undefined}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <ExpenseForm
            adding={false}
            editing={editing}
            isEditable={isEditable}
            expense={expense}
            codes={codes}
            users={users}
            onCancel={this.handleCancel}
            auth={auth}
            history={history}
            onSave={this.handleSave}
            hideReceiptDelete={false}
            saving={this.props.savingExpense}
          />
        </div>
      </React.Fragment>
    );
  }
}

ExpenseEditPage.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object.isRequired,
  users: PropTypes.array,
  codes: PropTypes.array,
  auth: PropTypes.object,
  expense: PropTypes.object,
  isMobile: PropTypes.bool,
  history: PropTypes.object,
  savingExpense: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    expense: state.reducers.expense,
    expenses: state.reducers.expenses,
    users: state.reducers.users,
    codes: state.reducers.codes,
    savingExpense: state.reducers.savingExpense
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...contractActions,
        ...customerActions,
        ...userActions,
        ...codeActions,
        ...expenseActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ExpenseEditPage);
